<template>
  <div class="pt-3">
    <div v-if="!loading && dataSet">
      <div class="my-2">
        <title-page
          title="Group List"
          back="true"
          colorIconBack="#006341"
        ></title-page>
      </div>
      <v-row no-gutters>
        <v-col
          v-if="permissions.includes('LD') || role == 'SUPERADMIN'"
          cols="12"
          sm="2"
          md="3"
          lg="4"
        >
          <div class="pa-2">
            <div class="create_group" @click="createData">
              <v-icon mr-2>mdi-plus</v-icon>
              <b>Add New Group</b>
            </div>
          </div>
        </v-col>
        <v-col
          cols="12"
          sm="2"
          md="3"
          lg="4"
          v-for="(item, i) in dataSet"
          :key="i"
        >
          <div class="pa-2">
            <v-card
              class="rounded_max pa-3 d-flex flex-column justify-space-between"
              flat
              height="200px"
              @click="toDetail(item)"
            >
              <div class="d-flex justify-space-between">
                <div class="d-flex">
                  <img
                    class="mr-2"
                    src="../../assets/img/group_default.png"
                    alt=""
                  />
                  <div>
                    <b>{{ item.title }}</b>
                    <p class="default_txt">
                      {{ item.group_member.length }} Member
                    </p>
                  </div>
                </div>
                <v-menu
                  v-if="permissions.includes('LD') || role == 'SUPERADMIN'"
                  offset-y
                  nudge-bottom="5px"
                  nudge-left="80px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>
                  <v-list class="pa-0" color="#EDF1F0" dense>
                    <v-list-item  @click="deleteData(item)">
                      <v-list-item-title>
                        <div class="d-flex align-center">
                          <v-icon color="red" class="mr-2"
                            >mdi-trash-can-outline</v-icon
                          >
                          <p class="ma-0 red--text">Delete</p>
                        </div>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item link>
                      <v-list-item-title @click="updateData(item)">
                        <v-icon class="mr-2">mdi-pencil-outline</v-icon>
                        Update
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <div class="d-flex">
                <v-avatar
                  dark
                  v-for="(avatar, idx) in item.ppl"
                  :key="`ava-${idx}`"
                  :class="idx > 0 ? 'next_ava' : 'first_ava'"
                  size="55"
                >
                  <img
                    v-if="avatar.user_data"
                    :src="
                      avatar.user_data.profile_picture
                        ? avatar.user_data.profile_picture
                        : ava
                    "
                    alt="avatar"
                    class="obj_fit"
                  />
                </v-avatar>
                <v-avatar
                  dark
                  color="#C4C4C4"
                  v-if="item.over"
                  class="next_ava"
                  size="55"
                >
                  <b>+{{ item.over }}</b>
                </v-avatar>
              </div>
            </v-card>
          </div>
        </v-col>
      </v-row>
      <div
        class="mt-3 d-flex align-center justify-center flex-column"
        v-if="!dataSet.length"
      >
        <img
          src="../../assets/img/gundam/LMS Aset Ilustration Empty Group.png"
          height="150px"
          alt=""
        />
        <b class="default_txt my-3"
          >You can add group for learning purpose here</b
        >
      </div>
    </div>
    <div v-if="loading">
      <v-row>
        <v-col cols="12" sm="2" md="3" lg="4" v-for="i in 3" :key="i">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>
    <div class="pa-2">
      <dialog-large
        :d_large="d_large"
        @refetch="fetchData"
        @close="d_large = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitlePage from "../../components/atom/titlePage.vue";
// import dialogLarge from "../dialog/dialogLarge.vue";
import DialogSmall from "../dialog/dialogSmall.vue";
export default {
  components: { DialogSmall, TitlePage },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
      ava: (state) => state.ava,
    }),
  },
  name: "listGorup",
  data() {
    return {
      dataSet: null,
      loading: false,
      d_create: false,
      d_small: false,
      d_large: false,
      inventory: null,
      d_type: "",
      d_title: "",
      thumbnail: {
        ppl: [],
        over: null,
      },
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/course/group?filter[course_id]=${this.$route.params.idCourse}&include=groupMember`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.dataSet.forEach((el) => {
            if (el.group_member.length > 3) {
              this.thumbnail.over = el.group_member.length - 3;
              el.group_member.forEach((x) => {
                this.thumbnail.ppl.push(x);
              });
              el["ppl"] = this.thumbnail.ppl.slice(0, 3);
              el["over"] = this.thumbnail.over;
            } else {
              el["ppl"] = el.group_member;
              el["over"] = null;
            }
          });
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: err.message,
            type: "error",
          });
        });
    },
    createData() {
      this.d_type = "c_group";
      this.d_title = "Add Group";
      this.d_large = true;
    },
    deleteData(item) {
      this.inventory = item;
      this.d_type = "d_group";
      this.d_title = "Delete Group";
      this.d_small = true;
    },
    updateData(item) {
      this.inventory = {
        member: item.group_member,
        group: item,
      };
      this.d_type = "u_group";
      this.d_title = "Update Group";
      this.d_large = true;
    },

    toDetail(item) {
      this.$router.push(
        `/group/detail/inclass/${this.$route.params.idCourse}/${item.id}`
      );
    },
  },
};
</script>

<style scoped>
.create_group {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 200px;
  background: #c7dbd4;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='20' ry='20' stroke='%23333' stroke-width='3' stroke-dasharray='11' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 20px;
  cursor: pointer;
  color: #8e9190;
}
.v-menu__content {
  box-shadow: none !important;
}
.first_ava {
  border: 2px #fff solid;
}
.next_ava {
  border: 2px #fff solid !important;
  margin-left: -25px;
}
</style>
